function replacePlaceholders(string, data) {
    if (!string) return;

    return string.replace(/{{(\w+)}}/g, (all, key) => data[key] || all);
};

export default replacePlaceholders;
